import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Grid, Typography } from "@mui/material";
import CommonButton from "../../common/components/CommonButton";
import { ProjectStatus, ProjecType } from "../../common/const";
import theme from "../../theme";
import ProjectDisplay from "./ProjectDisplay";

const ExternalProject = ({
    setProjectType,
    projectList
}) => {
    return projectList.length > 0 ? (
        <CommonCard
            paddingBottom="0px"
            borderRadius={2}
            padding="0px 13px 13px 13px"
            headerContent={
                <Fragment>
                    <Box
                        sx={{ padding: '13px 13px 13px 13px' }}
                    >
                        <Typography fontWeight={600}>Project List</Typography>
                        <Typography fontSize={14} color={theme.palette.background.dark}>Lorem ipsum dolor sit amet</Typography>
                    </Box>
                </Fragment>
            }
            content={
                <Box
                    mt={1}
                    sx={{
                        height: '52vh',
                        overflow: 'auto'
                    }}
                >
                    <Box>
                        <Typography fontWeight={600}>In Progress Projects</Typography>
                        {projectList.filter((i) => i.status === ProjectStatus.InProgress).length > 0 ? (
                            <Grid container spacing={2}>
                                {projectList.filter((i) => i.status === ProjectStatus.InProgress).map((a, index) => (
                                    <ProjectDisplay a={a} index={index} />
                                ))}
                            </Grid>
                        ) : (
                            <Typography textAlign="center" color={theme.palette.background.dark}>No Project Found</Typography>
                        )}
                    </Box>
                    <Box mt={3}>
                        <Typography fontWeight={600}>Enrolled Projects</Typography>
                        {projectList.filter((i) => i.status === ProjectStatus.Enrolled).length > 0 ? (
                            <Grid container spacing={2}>
                                {projectList.filter((i) => i.status === ProjectStatus.Enrolled).map((a, index) => (
                                    <ProjectDisplay a={a} index={index} />
                                ))}
                            </Grid>
                        ) : (
                            <Typography textAlign="center" color={theme.palette.background.dark}>No Project Found</Typography>
                        )}
                    </Box>
                    <Box mt={3}>
                        <Typography fontWeight={600}>Completed Projects</Typography>
                        {projectList.filter((i) => i.status === ProjectStatus.Completed).length > 0 ? (
                            <Grid container spacing={2}>
                                {projectList.filter((i) => i.status === ProjectStatus.Completed).map((a, index) => (
                                    <ProjectDisplay a={a} index={index} />
                                ))}
                            </Grid>
                        ) : (
                            <Typography textAlign="center" color={theme.palette.background.dark}>No Project Found</Typography>
                        )}
                    </Box>
                </Box>
            }
        />
    ) : (
        <CommonCard
            paddingBottom="0px"
            borderRadius={2}
            content={
                <Box display="flex" gap={0.5} flexDirection="column" alignItems="center" mt={2}>
                    <img src="/Images/externalProject.png" alt="External Project" width="100px" height="100px" />
                    <Typography fontWeight={600} fontSize={19}>You don’t have any active external project</Typography>
                    <Typography color={theme.palette.background.dark} fontSize={12}>Add the research work or projects you’ve completed.</Typography>
                    <CommonButton
                        label="Find New Project"
                        fontWeight={600}
                        width="170px"
                        marginTop={1.5}
                        height="35px"
                        handleClick={() => setProjectType(ProjecType.EXPLORE)}
                    />
                </Box>
            }
        />
    )
}

export default ExternalProject;